import noWorkoutsImage from '../../../../asset/image/no-workouts.png'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { EmptyState } from 'src/component/profile/empty-state/empty-state'
import { ProfileSection } from 'src/component/profile/profile-section/profile-section'
import { WorkoutPopup } from 'src/component/programmes/programme-workout-popup'
import { OutlinedButton } from 'src/component/ui/button'
import { Grid } from 'src/component/ui/grid/grid'
import { SeeAll } from 'src/component/ui/see-all'
import { WorkoutCard } from 'src/component/ui/workout-card'
import { WorkoutCardSkeleton } from 'src/component/ui/workout-card/workout-card-skeleton'
import { CompletedWorkout, Workout } from 'src/dao/core-dao'
import { useProfileSection } from 'src/hook/use-profile-section'
import { useCompletedWorkouts } from 'src/hook/use-workouts'
import { toasterUtil } from 'src/util/toaster-util'

export const CompletedWorkouts = (): React.ReactElement => {
  const [selectedWorkout, setSelectedWorkout] = useState<Workout | undefined>(undefined)

  const {
    data: completedWorkouts,
    isLoading,
    isError,
  } = useCompletedWorkouts(
    {
      orderField: 'completedAt',
      orderDirection: 'DESC',
    },
    {
      onError: () => {
        toasterUtil.error('We are having difficulties loading your completed workouts, please try again.')
      },
    },
  )

  const { items, isEmpty, hasMore, shouldShowSkeleton } = useProfileSection<CompletedWorkout, Workout>({
    data: completedWorkouts,
    isLoading,
    isError,
    extractItem: (cw) => cw.workout,
  })

  return (
    <ProfileSection theme="dark">
      <ProfileSection.Header>
        <ProfileSection.Title>COMPLETED WORKOUTS</ProfileSection.Title>
        {!isLoading && !isError && hasMore && <SeeAll seeAllLink="/completed-workouts" theme="dark" />}
      </ProfileSection.Header>

      <ProfileSection.Content
        isLoading={shouldShowSkeleton}
        isEmpty={isEmpty}
        skeleton={
          <Grid.Skeleton>
            <WorkoutCardSkeleton />
          </Grid.Skeleton>
        }
        empty={
          <EmptyState
            theme="dark"
            image={noWorkoutsImage}
            message="No completed workouts found, please explore our list of workouts!"
            action={
              <OutlinedButton asChild className="border-ivory text-ivory">
                <Link to="/workouts">SEE ALL WORKOUTS</Link>
              </OutlinedButton>
            }
          />
        }
      >
        <Grid
          items={items}
          keyExtractor={(w) => w.id}
          renderItem={(workout: Workout) => (
            <WorkoutCard.List workout={workout} isCompleted={true} onAction={() => setSelectedWorkout(workout)} />
          )}
        />
      </ProfileSection.Content>

      <WorkoutPopup
        setOnClose={() => setSelectedWorkout(undefined)}
        selectedWorkout={selectedWorkout}
        startWorkoutLink={selectedWorkout ? `/workouts/${selectedWorkout.id}` : undefined}
      />
    </ProfileSection>
  )
}
